<script setup lang="ts"></script>

<template>
  <div class="embed-layout h-full">
    <slot />
  </div>
</template>
